import { useMemo } from 'react';

import { usePersonasPolling } from './usePersonasPolling';

/**
 * Resolves a single persona from the workspace list while polling for
 * background creation updates.
 */
export const usePersonaPolling = (
  personaId: string | undefined,
  workspaceId: string | null | undefined,
) => {
  const { data: personas, isPending, isError, error, refetch } = usePersonasPolling(workspaceId);

  const persona = useMemo(() => {
    if (!personas || !personaId) return null;
    return personas.find((p) => p.id === personaId) ?? null;
  }, [personas, personaId]);

  return {
    data: persona,
    isPending,
    isError,
    error,
    isNotFound: !isPending && !isError && !persona && !!personaId,
    refetch,
  };
};
